// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iSPpG","icon":"styles_icon__1iwnB"};